module.exports = __webpack_public_path__ + "static/media/demo.1e2ea0fa.gif";